const apiBase = process.env.REACT_APP_API;

export const getQuota = async (courseId) => {
  if (!courseId) {
    throw new Error("Course ID is required");
  }

  const response = await fetch(
    `${apiBase}/courses/getquota?course_id=${courseId}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ course_id: courseId }),
    }
  );

  if (!response.ok) {
    const errorText = await response.text().catch(() => "Unknown error");
    throw new Error(
      `Failed to fetch quota data (${response.status}): ${errorText}`
    );
  }

  const data = await response.json();
  return data;
};

export const getAllQuotas = async (courseId) => {
  if (!courseId) {
    throw new Error("Course ID is required");
  }

  const response = await fetch(`${apiBase}/quota/course/${courseId}`);

  if (!response.ok) {
    const errorText = await response.text().catch(() => "Unknown error");
    throw new Error(
      `Failed to fetch quotas (${response.status}): ${errorText}`
    );
  }

  const data = await response.json();
  return data;
};

export const getQuotaById = async (quotaId) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(`${apiBase}/quota/${quotaId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`Error fetching quota: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error(`Failed to fetch quota with ID ${quotaId}:`, error);
    throw error;
  }
};

export const createQuota = async (quotaData) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(`${apiBase}/quota`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(quotaData),
    });

    if (!response.ok) {
      throw new Error(`Error creating quota: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Failed to create quota:", error);
    throw error;
  }
};

export const deleteQuota = async (quotaId) => {
  try {
    const response = await fetch(`${apiBase}/quota/${quotaId}`, {
      method: "DELETE",
    });

    if (!response.ok) {
      throw new Error(`Error deleting quota: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error(`Failed to delete quota with ID ${quotaId}:`, error);
    throw error;
  }
};

export const updateQuota = async (quotaId, quotaData) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(`${apiBase}/quota/${quotaId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${token}`

      },
      body: JSON.stringify(quotaData),
    });

    if (!response.ok) {
      throw new Error(`Error updating quota: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error(`Failed to update quota with ID ${quotaId}:`, error);
    throw error;
  }
};
